import Vue from 'vue'

import App from './AppNewIARC.vue'
import router from './router.js'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './i18n'
import { Trans } from './plugins/Translation.js'
import Func from './func.js'
import PrimeVue from 'primevue/config';

// global 
// import store from '@/store.js'
import store from '@/subsites/iacr/store.js'

let uri     = window.location.search.substring(1); 
let params  = new URLSearchParams(uri) , embed = params.get('embed') ;

import AppEmbed from './AppEmbed.vue'

Vue.prototype.$i18nRoute = Trans.i18nRoute.bind( Trans )
//Vue.config.productionTip = false;
Vue.config.devtools = true ;

import ConstProject from '@/subsites/iacr/const.js'
import AgeSpecificConf from '@/subsites/iacr/conf/visualisations/AgeSpecific.json'
import AgeSpecificConfCI5Plus from '@/subsites/iacr/conf/visualisations/AgeSpecificCI5Plus.json'
import TablesConf from '@/subsites/iacr/conf/visualisations/Tables.json'
import TablesCI5PlusConf from '@/subsites/iacr/conf/visualisations/TablesCI5Plus.json'
import PopPyramidConf from '@/subsites/iacr/conf/visualisations/PopulationPyramid.json'
import PopPyramidConfCI5Plus from '@/subsites/iacr/conf/visualisations/PopulationPyramidCI5Plus.json'
import BarsConf from '@/subsites/iacr/conf/visualisations/Bars.json'
import BarsConfCI5Plus from '@/subsites/iacr/conf/visualisations/BarsCI5Plus.json'
import TrendsConf from '@/subsites/iacr/conf/visualisations/Trends.json'

import TrendsAccrossVolumesConf from '@/subsites/iacr/conf/visualisations/TrendsAccrossVolumes.json'
import BarCompareConf from '@/subsites/iacr/conf/visualisations/BarCompare.json'
import RankingConf from '@/subsites/iacr/conf/visualisations/Ranking.json'
import VolumeConf from '@/subsites/iacr/conf/visualisations/Volume.json'

import DicConf from '@/subsites/iacr/conf/visualisations/Dic.json'

import WorldCities from '@/subsites/iacr/assets/data/world-cities.json'
import PopulationsAndCities from '@/subsites/iacr/assets/data/populations-and-cities.json'
import CI5_Full from '@/subsites/iacr/assets/data/ci5_full.json'


store.commit('setConst', ConstProject)

store.commit('setConf', {
	age_specific : AgeSpecificConf ,
	age_specific_ci5plus : AgeSpecificConfCI5Plus ,
	tables : TablesConf ,
	tables_ci5plus: TablesCI5PlusConf ,
	population_pyramid : PopPyramidConf ,
	population_pyramid_ci5plus : PopPyramidConfCI5Plus ,
	bars : BarsConf , 
	bars_ci5plus : BarsConfCI5Plus ,
 	barCompare : BarCompareConf , 
	trends_accross_volumes : TrendsAccrossVolumesConf ,
	trends : TrendsConf ,
	ranking : RankingConf , 
	volume : VolumeConf , 
	dic : DicConf
}) ; 

store.commit('setDevice' , {
	md : new MobileDetect( navigator.userAgent ) , 
	window : { w : $(window).width() , h : $(window).height() }
})

var Default = {
	width : 1140 , 
	height : 1683 , 
	width_pie : 764 - 20 ,  
	pie_items : 5 , 
	pie_margin : 50 , 
	registries : [] , 
	third_page : false , 
	extra_registries : '' ,
	title_font_size : ''
} ; 

let url_api 		= process.env.VUE_APP_API  ; 
let base_url_api 	= url_api ;
url_api = url_api.replace('[vdb]',ConstProject.data_version) ; 

let promises 		= [
    // cancer site list 
    axios.get( url_api + 'meta/cancers/all/' ) ,
    // pops list 
    axios.get( url_api + 'meta/populations/all/' )

] ; 

// pre load cancer one time and commit them to store
axios.all( promises )

	.then( axios.spread(( cancers_promise , populations_promise ) => {
		
		let world_cities = WorldCities ; 
		let cpt = 0 , cities_unfound = []; 
		let populations = populations_promise.data , volumes_in = [] , volumes = [] ; 

		volumes_in = [{ volume : '01' , years : '1960-1962' } ,
					  { volume : '02' , years : '1963-1966' } ,
					  { volume : '03' , years : '1968-1972' } ,
					  { volume : '04' , years : '1973-1977' } ,
					  { volume : '05' , years : '1978-1982' } ,
					  { volume : '06' , years : '1983-1987' } ,
					  { volume : '07' , years : '1988-1992' } ,
					  { volume : '08' , years : '1993-1997' } ,
					  { volume : '09' , years : '1998-2002' } ,
					  { volume : '10' , years : '2003-2007' } ,
					  { volume : '11' , years : '2008-2012' } ,
					  { volume : '12' , years : '2013-2017' } ] ;

		let romans = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'] ;
		let years_ = ['1960-1962','1963-1966','1968-1972','1973-1977','1978-1982','1983-1987','1988-1992','1993-1997','1998-2002','2003-2007','2008-2012','2013-2017'] ;
		let all_years = { min : [] , max : []} ; 

		volumes = d3.nest()
			.key( v => v.volume )
			.entries( volumes_in )
			.map( v => {
				let roman = romans[parseFloat(v.key)-1] ;
				let year_ = years_[parseFloat(v.key)-1]
				let ext = 'png' , volum_str = v.key ; 
				
		        if ( parseFloat( v.key ) < 10) volum_str = volum_str.replace('0','')
		        if ( [7,8,9,12].includes( parseFloat( v.key ) )) ext = 'jpg' ; 
		        if ( [1,2,3,4,5,6].includes( parseFloat( v.key ) )) ext = 'gif' ; 
		        if ( [1,2,3,4,5,6,10].includes(parseFloat( v.key ) )) volum_str = volum_str+'a' ; 

		        let y_ = v.values.map( y => y.years.split('-') ) ; 

		        all_years.min.push( parseInt( y_[0] ) )
		        all_years.max.push( parseInt( y_[1] ) )

		        // console.info(" Years => " , `Volume ${roman}` , all_years ) ; 
		        let image = `${process.env.VUE_APP_GCO_MEDIAS}/ci5/img/ci5v${volum_str}.${ext}` ; 
		        let name = `Volume ${roman}` ;
				return {
					order : parseFloat(v.key),
					label : roman,
					label_long : `CI5 Volume ${roman}`,
					volume : v.key , 
					value : v.key , 
					name : name , 
					years : year_ , // v.values[0].years , 
					period : year_ , // v.values[0].years , 
					url : `/iacr/en/ci5-2.0/volume/${v.key}/` , 
        			desc : year_ , //v.years , 
        			tooltipHTML :  `<div class="container_tooltip" style="width:110px ; height:130px;"><img src="${image}" class="img_tooltip" alt="${name}" /><br> <strong>${year_}</strong></div>`,
        			image : image
				}
			})
			.sort((a,b) => (b.order-a.order))

		// console.info(" volumes " ,  volumes ) ; 

		/*let ci5_full_ =  CI5_Full.map( population => {
			// population.label_ = population.label ;
			// population.label += ` (${population.period})` ;
			// find code
			if ( population.country_code < 100 ) population.country_code = `0${population.country_code}` ;
			// console.info("population",population.registry_label,population.country) ; 
			// find localisation$
			
			let base_find_city = "" ;

			// if ( population.registry_label == 'Bulawayo: African')
			if ( population.contact == undefined )
			{
				
				cpt++ ; 

				let pattern = population.registry_label ; 
				pattern = pattern.replace('City','')
				pattern = pattern.replace('China,','')
				pattern = pattern.replace('USA','')
				pattern = pattern.replace('County','')
				pattern = pattern.replace(' State','')
				pattern = pattern.replace(', ','')
				pattern = pattern.replace('France','')
				pattern = pattern.replace('District','')

				let city_reg = pattern.split(',') ; 
				population.city_registry = ( city_reg.length > 1 ) ? city_reg[1] : city_reg[0] ; 

				base_find_city = population.city_registry
				
				cities_unfound.push( pattern )


				if (base_find_city.includes('SEER')) base_find_city = 'Maryland';
				if (base_find_city.includes('NPCR')) base_find_city = 'Atlanta';
				if (base_find_city.includes('Calvados')) base_find_city = 'Caen';
				if (base_find_city.includes('Belfort')) base_find_city = 'Belfort';
				if (base_find_city.includes('Aosta')) base_find_city = 'Aosta';
				if (base_find_city.includes('AustraliaNorthern Territory')) base_find_city = 'Northern Territory';
			
				let city = world_cities.find( w => slugify( w.city ) == slugify( base_find_city ) ) ; 

				if ( city == undefined ) city =  world_cities.find( w => ( w.admin_name == base_find_city || w.country == base_find_city )) ; 

				console.info("NOT Foundbase_find_city","["+base_find_city+"]","=>via city & admin_name",city) ; 

				// let city = world_cities.find( w => w.capital == 'i' ) ; 
				//console.info(" Searching ..." , base_find_city , city  ) ; 

				if ( city != undefined ){
					console.info(" FOUND" , city_reg , city ) ; 
					if ( population.contact == undefined ) population.contact = {}
					population.contact.city = city
				}
			}
			return population ; 
		}) */

		store.commit('setDictionnay', {
			cancers_promise : cancers_promise.data ,
			// populations_promise : PopulationsAndCities
			populations_promise : populations , 
			volumes : volumes , 
			// world_cities : WorldCities
		}) ; 


		/*console.info({
			'NOT FOUND = ': cpt , 
			CI5_Full : ci5_full_ , 
			//populations : store.state.dictionnary.populations_promise , 
			cities_unfound : cities_unfound 
		});*/

		Vue.use(BootstrapVue, {
		  BvToast: {
		    autoHideDelay: 10000,  // 👈 suspicious
		    noAutoHide: false,
		    toaster: 'b-top-right'
		  }
		})

		new Vue({
		  router,
		  store,
		  i18n,
		  // BootstrapVue,
		  PrimeVue,
		  render: h => h( (embed==1)?AppEmbed:App)
		}).$mount('#app')

		Vue.filter('formatRate', function(value) {
		  return formatRate(value);
		});

	}))
    // eslint-disable-next-line
    .catch( error => {
        console.error("Error catched",error) ; 
        // this.error = true

    	// in that case, just make a fallback
    
        new Vue({
		  router,
		  store,
		  i18n,
		  BootstrapVue,
		  PrimeVue,
		  render: h => h( (embed==1)?AppEmbed:App)
		}).$mount('#app')
    })
    .finally(() => {

    })

/*window.onerror = function (msg, url, line, col, error) {
  console.error('Global error caught:', msg, error)
}*/

	